import { Injectable, Inject } from '@angular/core';
import { ApplicationService } from '../../services/application.service';
import { ConstantsService } from '../../services/constants.service';
import { SetupService } from '../../services/setup.service';
import { UtilsService } from '../../services/utils.service';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MainMenuService {

    params: any;

    constructor(
        @Inject('$rootScope') private $rootScope: angular.IRootScopeService & { [name: string]: any },
        private applicationService: ApplicationService,
        private constants: ConstantsService,
        private setupService: SetupService,
        private utils: UtilsService,
        private location: Location,
    ) {}


    applicationID: any = null;
    applicationOptions: any = null;
    setupMenuId: any = null;
    setupMenu: any = null;

    Navigate(item, selectedAppId) {
        if (!item || !item.displayType) {
            this.location.go('home');
            return;
        }

        switch (item.displayType) {

            case ('generator'):
                this.utils.OpenModal("", "ng1/src/scheduleGenerator/scheduleGeneratorModal.html", 'ScheduleGeneratorController', null, null, null, null);
                break;

            case ('grid'):
                this.GetSetupMenu(selectedAppId, item.id).then((menu: any) => {
                    this.location.go(item.displayType + '/' + menu.items[0].type + '/' + item.id + '/' + menu.items[0].id);
                });
                break;

            case ('page'):
                this.location.go(item.displayType + '/' + item.htmlPageId);
                break;

            case ('reports'):
            case ('calendar'):
            case ('dashboard'):
            case ('preview'):
                this.location.go(item.displayType + '/' + item.id);
                break;

            default:
                this.location.go(item.displayType);
                break;
        }
    }

    GetMenu(appId, reload) {
        var promise = new Promise((resolve, reject) => {
            if (this.location.path().indexOf('grid') !== -1 || this.location.path().indexOf('preview') !== -1) {
                const params = this.location.path().split('/').reverse();
                this.GetSetupMenu(appId, params[1] || params[2]).then((menu) => {
                    resolve(menu);
                });
            }
            else {
                this.GetApplicationOptions(appId, false).then((menu) => {
                    if (reload) {
                        window.location.reload();
                    }

                    resolve(menu);
                });
            }
        });
        return promise;
    }

    GetApplicationOptions(appId, reset) {

        let promise = new Promise((resolve, reject) => {

            if (reset || !this.applicationOptions || this.applicationID !== appId) {

                this.applicationID = appId;

                this.$rootScope.userDataLoaded = false;

                this.applicationService.GetApplicationOptions(appId).then((response: any) => {
                    if (response.success) {
                        this.applicationOptions = response.data;
                        this.applicationOptions.type = this.constants.MainMenu.Types.Default;

                        resolve(this.applicationOptions);
                        this.$rootScope.userDataLoaded = true;
                    } else {
                       reject();
                    }
                });
            } else {
                this.applicationOptions.withoutRefresh = true;
                resolve(this.applicationOptions);
            }


        });

        return promise;
    }

    HideMenu() {
        setTimeout(function hide () {
            if ($('#page-content').length && $('.navbar-collapse').length) {
                $('#page-content').removeClass('out');
                $('.navbar-collapse').removeClass('in');
                $("#overlayCover").removeClass('menuOverlay');
            } else {
                setTimeout(hide, 100);
            }
        }, 1);
       
    }

    ShowMenu() {
        setTimeout(function show () {
            if ($('#page-content').length && $('.navbar-collapse').length) {
                $('#page-content').addClass('out');
                $('.navbar-collapse').addClass('in');
                $("#overlayCover").addClass('menuOverlay');
            }
            else {
                setTimeout(show, 100);
            }
        }, 1);
    }

    //private methods

    GetSetupMenu(appId, id) {
        let promise = new Promise((resolve, reject) => {
            if (!this.setupMenu || parseInt(id) !== parseInt(this.setupMenuId)) {
                this.setupMenuId = id;
                this.setupService.GetMenu(appId, id).then((response: any) => {
                    if (response.success) {
                        this.setupMenu = response.data;
                        this.setupMenu.type = this.constants.MainMenu.Types.Setup;
                        resolve(this.setupMenu);
                    } else {
                        reject();
                    }
                });
            } else {
                resolve(this.setupMenu);
            }
        });
        return promise;
    }

    GetIcon(type) {
        switch (type) {
            case ('Searches'):
                return 'assets/icons/ui-24px-outline-1_zoom-bold.svg';
            case ('Home'):
                return 'assets/icons/home-simple-glyph-24.svg';
            case ('Main'):
                return 'assets/icons/calendar-60-outline-24.svg';
            case ('Reports'):
                return 'assets/icons/single-content-03-outline-24.svg';
            case ('Dashboard'):
                return 'assets/icons/files-24px-outline_folder-14 (1).svg';
            case ('Setup'):
                return 'assets/icons/settings-gear-63-glyph-24.svg';
            case ('Charts'):
                return 'assets/icons/ui-24px-outline-3_chart-bars (1).svg';
            case ('Back'):
                return 'assets/icons/tail-triangle-left-glyph-16.svg';
            default:
                return 'assets/icons/files-24px-outline_archive-content.svg';
        }
    }

    GetFirstSetupMenuItem(appId, id) {
        let promise = new Promise((resolve, reject) => {
            this.GetSetupMenu(appId, id).then((menu: any) => {
                resolve(menu.items[0]);
            });
        });
        return promise;
    }

    Dispose() {
        this.applicationID = null;
        this.applicationOptions = null;
        this.setupMenuId = null;
        this.setupMenu = null;
    }
}
